The source that initially posted the job ad.

This can be used to determine the source of the job ad posting, and whether to display & enable functionality for the job ad.

Currently, four codes are defined:

- `CurrentPartner` indicates the job ad was posted by the requesting partner. This will accompany a `seekCreatedBySelfIndicator` value of `true`.

- `Seek` indicates the job ad was posted via the SEEK employer website. This will accompany a `seekCreatedBySelfIndicator` value of `false`.

- `AdSync` indicates the job ad was posted via the SEEK Ad Sync integration. This will accompany a `seekCreatedBySelfIndicator` value of `false`.

- `Other` indicates the job ad was posted via another source, including a separate SEEK API partner or other SEEK posting methods. This will accompany a `seekCreatedBySelfIndicator` value of `false`.
